import { useQuery } from "@tanstack/react-query";
import { ordersApi } from "../api/ordersApi";
import { ordersKeys } from "../api/ordersKeys";

/** Loads an order (or custom order) using its private tracking token. */
export function useTrackOrder(token, { custom = false } = {}) {
  return useQuery({
    queryKey: custom ? ordersKeys.trackCustom(token) : ordersKeys.track(token),
    queryFn: () => (custom ? ordersApi.trackCustom(token) : ordersApi.track(token)),
    enabled: Boolean(token),
    // A bad token is a permanent 404; retrying just delays the error message.
    retry: false,
  });
}
